"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Skeleton.scss");
const Skeleton = _ref => {
  let {
    className,
    cells = 5,
    rows = 6
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames.default)('cds-DataTable', 'cds-Skeleton-Wrapper--Pulse', 'cds-Table--Bordered', 'cds-Table–-FullWidth', className)
  }, /*#__PURE__*/_react.default.createElement("tbody", null, Array(rows).fill(null).map((r, rowIndex) => /*#__PURE__*/_react.default.createElement("tr", {
    className: "cds-DataTable-BodyRow",
    key: (0, _key.createKey)('bodyRow', rowIndex)
  }, Array(cells).fill(null).map((c, cellIndex) => /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-DataTable-BodyCell cds-Skeleton--TextFull",
    key: (0, _key.createKey)(rowIndex, cellIndex)
  }))))));
};
exports.Skeleton = Skeleton;
//# sourceMappingURL=Skeleton.js.map